import { useEffect, useState } from '@wordpress/element';
import styles from "./CheckboxGroup.module.css";

const CheckboxGroup = ({ label, options = [], selectedValues = [], onChange }) => {
  const [checkedValues, setCheckedValues] = useState(selectedValues);

  // Update internal state when selectedValues prop changes
  useEffect(() => {
    console.log('🔄 [CheckboxGroup] selectedValues prop changed:', selectedValues);
    setCheckedValues(selectedValues);
  }, [selectedValues]);

  const handleCheckboxChange = (value) => {
    let updatedValues;
    if (checkedValues.includes(value)) {
      updatedValues = checkedValues.filter((v) => v !== value);
    } else {
      updatedValues = [...checkedValues, value];
    }
    console.log('✅ [CheckboxGroup] Checkbox changed:', value, 'New values:', updatedValues);
    setCheckedValues(updatedValues);
    if (onChange) onChange(updatedValues);
  };

  return (
    <div className={styles["hvnly_settings_api__form-group"]}>
      {label && (
        <label className={styles["hvnly_settings_api__form-label"]}>{label}</label>
      )}

      {options.map((option) => (
        <div className={styles["hvnly_settings_api__checkbox-group"]} key={option.value}>
          <input
            type="checkbox"
            id={option.id || `checkbox-${option.value}`}
            checked={checkedValues.includes(option.value)}
            onChange={() => handleCheckboxChange(option.value)}
          />
          <label htmlFor={option.id || `checkbox-${option.value}`} className={styles["hvnly_settings_api__checkbox"]}></label>
          <span className={styles["hvnly_settings_api__toggle-label"]}>
            {option.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CheckboxGroup;